<script setup>
import PopupMenu from '@/components/PopupMenu.vue'
import { ref } from 'vue'
import SidebarMenu from '../components/SidebarMenu.vue'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from '@/components/dropdown-menu'
import GbButton from '@/components/GbButton.vue'
const lists = [
  {
    heading: 'LIBRARY',
    items: [
      { label: 'All Folders', url: '/library' },
      { label: 'Recently Saved', selected: true, url: '/library/recent-folders' },
      { label: 'Archived', url: '/library/archived-folders' }
    ]
  },
  {
    heading: 'RECENTLY VIEWED',
    items: [
      { label: 'Goals', url: '/library/recent-goals' },
      { label: 'Strategies', url: '/library/recent-strategies' },
      { label: 'Resources', url: '/library/recent-resources' }
    ]
  }
]
const popUpItems = ref([
  {
    label: 'Open',
    isRouterLink: true,
    route: '/folder/xyz'
  },
  {
    label: 'Rename',
    action: openModal
  },
  {
    label: 'Share',
    action: openModal
  },
  {
    label: 'Archive',
    action: openModal
  },
  {
    label: 'Delete',
    action: openModal
  }
])

function openModal() {
  alert('hello world')
}
</script>
<template>
  <div class="grid grid-cols-4 gap-4">
    <div class="pt-2">
      <h3 class="header-md pb-1">Sidebar Menu</h3>
      <SidebarMenu :lists="lists" title="YOUR CONTENT" />
    </div>
    <div class="pt-2">
      <h3 class="header-md pb-1">Popup Menu</h3>
      <PopupMenu :items="popUpItems" />
    </div>
    <div class="pt-2">
      <h3 class="header-md pb-1">Shadcn Dropdown Menu (unstyled)</h3>
      <div class="flex flex-wrap gap-4">
        <DropdownMenu>
          <DropdownMenuTrigger as-child>
            <GbButton size="small">Open Menu</GbButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent class="w-56" align="start">
            <DropdownMenuLabel>My Account</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem>Profile</DropdownMenuItem>
            <DropdownMenuItem>Billing</DropdownMenuItem>
            <DropdownMenuItem>Settings</DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuSub>
                <DropdownMenuSubTrigger>More Options</DropdownMenuSubTrigger>
                <DropdownMenuSubContent>
                  <DropdownMenuItem>About</DropdownMenuItem>
                  <DropdownMenuItem>Help</DropdownMenuItem>
                  <DropdownMenuItem disabled>API</DropdownMenuItem>
                </DropdownMenuSubContent>
              </DropdownMenuSub>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem class="text-red-300">Log out</DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>

        <DropdownMenu>
          <DropdownMenuTrigger as-child>
            <GbButton size="small">Share</GbButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent class="w-56" align="start">
            <DropdownMenuLabel>Share Options</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuItem>Share with User</DropdownMenuItem>
              <DropdownMenuItem>Share with Team</DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem>Copy Link
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  </div>
</template>
